import { alpha } from '@mui/material/styles';

// SETUP COLORS
const GREY = {
  0: "#FFFFFF",
  100: "#F9FAFB",
  200: "#F4F6F8",
  300: "#DFE3E8",
  400: "#C4CDD5",
  500: "#919EAB",
  600: "#637381",
  700: "#454F5B",
  800: "#212B36",
  900: "#161C24",
  1000: "#0A0A0A", // Darkest background color
};

const PRIMARY = {
  lighter: "#0ea84c",
  light: "#0ea84c",
  main: "#0c6831",
  dark: "#2f3366",
  darker: "#2f3366",
  contrastText: "#fff",
  hover: "#4caf504f",
};

const SECONDARY = {
  lighter: "#d6f2ff",
  light: "#85d9ff",
  main: "#D95323",
  dark: "#1686b8",
  darker: "#0b587a",
  contrastText: "#fff",
};

const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#54D62C',
  dark: '#229A16',
  darker: '#08660D',
  contrastText: GREY[100],
};

const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#a11846',
  dark: '#B78103',
  darker: '#7A4F01',
  contrastText: GREY[100],
};

const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#FF4842',
  dark: '#B72136',
  darker: '#7A0C2E',
  contrastText: '#fff',
};

const palette = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[500], 0.24),
  text: {
    primary: GREY[100],
    secondary: GREY[300],
    disabled: GREY[600],
  },
  background: {
    paper: GREY[900],
    default: GREY[1000],
    neutral: GREY[800],
  },
  action: {
    active: GREY[300],
    hover: alpha(GREY[300], 0.08),
    selected: alpha(GREY[300], 0.16),
    disabled: alpha(GREY[300], 0.8),
    disabledBackground: alpha(GREY[300], 0.24),
    focus: alpha(GREY[300], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
